import { Address, EditAddressOperationType, EditAddressResponsePayload } from "@swiggy-private/native-bridge";
import { getBridgeSdk } from "@swiggy-private/checkout-core";
import { SOCIAL_OFO_TEXT } from "@cart-client/constants/TextDict";
import { UserAddress } from "@swiggy-private/cart-types";

export async function openEditNumberBottomSheet(
    selectedAddress: UserAddress,
    actionText?: string,
): Promise<EditAddressResponsePayload | undefined> {
    let actionType = EditAddressOperationType.EDIT_RECEIVER_DETAILS_HALF_CARD;
    if (actionText === SOCIAL_OFO_TEXT.changeAction) {
        actionType = EditAddressOperationType.ADD_RECEIVER_DETAILS_HALF_CARD_2;
    }
    return getBridgeSdk().editAddress({
        tenant: {
            marketplaceBusinessline: "Regular",
            marketplaceCategory: "Food",
            marketplaceId: 1,
        },
        address: {
            ...selectedAddress,
            annotationTag: selectedAddress.addressCategory,
            userIntentAnnotationTag: selectedAddress?.userIntentAddressCategory,
        } as Address,
        enabled: [],
        focused: null,
        actionType: actionType,
    });
}
